<template>
	<div class="width-100 height-100">
		<template v-if="isFirstBlock">
			<template v-if="isOfTypeTool">
				<div @click="onClickBlock(block)">
					<ToolPlacementTreeBlockDataProvider :blockData="block" />
				</div>
			</template>
			<template v-else-if="isRootNodeOfSubFlow(block)">
				<div class="relative cursor-pointer" @click="onClickBlock(block)">
					<SubflowRootTreeBlock :blockData="block" />
				</div>
			</template>
			<template v-else>
				<FlowTreeBlockDataProvider
					v-if="hasLoadedNodesData"
					v-on="$listeners"
					class="mb-1"
					isFirstBlock
					:blockData="block"
					@remove-temp="removeTempBlock"
					@clickBlock="onClickBlock(block)"
				/>
			</template>
		</template>

		<div v-else class="relative">
			<div class="iasync_icon" v-if="block.async_run_after_all_previous_flag">
				<SIcon name="iasync-down" title="Run after previous steps" />
			</div>
			<template v-if="showNotificationSpecialNode(block)">
				<div class="" @click="onClickBlock(block)">
					<NotificationTreeBlock :notification="block.notification" :blockData="block" />
				</div>
			</template>
			<FlowTreeBlockDataProvider
				v-else-if="hasLoadedNodesData"
				v-on="$listeners"
				class="mb-1"
				:blockData="block"
				:isContextualBlock="isContextualNode(block)"
				@remove-temp="removeTempBlock"
				@clickBlock="onClickBlock(block)"
			/>

			<div class="iasync_icon" v-if="block.async_before_all_following_flag">
				<SIcon name="iasync-up" title="Run before next steps" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isOfTypeFeature, isOfTypeTool, isRootNodeOfSubFlow } from '@/store/modules/selectedWorkflow/getters';

import * as WorkflowNodeService from '@/utils/workflow-node-service';
import FlowTreeMixin from './FlowTreeMixin';

import FlowTreeBlockDataProvider from './FlowTreeBlock/FlowTreeBlockDataProvider';

import ToolPlacementTreeBlockDataProvider from './FlowTreeBlock/ToolPlacementTreeBlockDataProvider.vue';
import NotificationTreeBlock from './FlowTreeBlock/NotificationTreeBlock.vue';
import SubflowRootTreeBlock from './FlowTreeBlock/SubflowRootTreeBlock';

import { getPlacement } from '@/store/modules/placements/getters';
import { getContext } from '@/store/modules/contexts/getters';
import { rootNodeId as rootNodeIdGetter } from '@/store/modules/workflows/getters';

export default {
	name: 'FlowTreeBlock',
	components: {
		FlowTreeBlockDataProvider,
		ToolPlacementTreeBlockDataProvider,
		NotificationTreeBlock,
		SubflowRootTreeBlock,
	},
	props: {
		block: { type: Object },
		hasLoadedNodesData: { type: Boolean },
	},
	mixins: [FlowTreeMixin],
	methods: {
		showNotificationSpecialNode(block) {
			return WorkflowNodeService.isSendNotification(block);
		},
	},
	computed: {
		...mapGettersShorthand({
			isOfTypeFeature,
			isOfTypeTool,
			isRootNodeOfSubFlow,
			getPlacement,
			getContext,
			rootNodeIdGetter,
		}),
		rootNodeId() {
			return this.rootNodeIdGetter(this.block.workflow, this.block.workflow_version);
		},
		isFirstBlock() {
			return this.block.id === this.rootNodeId;
		},
	},
};
</script>
<style scoped lang="scss">
.iasync_icon {
	padding-left: 138px;
	background: #fafcff;
}
</style>
